import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit {
  title = '';
  text = '';
  confirmButtonText = 'OK';
  cancelButtonText = 'Cancel';

  constructor(
    @Inject(MAT_DIALOG_DATA)
    private readonly data: {
      title: string;
      text: string;
      confirmButtonText?: string;
      cancelButtonText?: string;
    }
  ) {}

  ngOnInit(): void {
    this.title = this.data.title;
    this.text = this.data.text;
    if (this.data.confirmButtonText) {
      this.confirmButtonText = this.data.confirmButtonText;
    }
    if (this.data.cancelButtonText) {
      this.cancelButtonText = this.data.cancelButtonText;
    }
  }
}
